import { render, staticRenderFns } from "./acceptTerms.vue?vue&type=template&id=19433e5e&scoped=true&"
import script from "./acceptTerms.vue?vue&type=script&lang=ts&"
export * from "./acceptTerms.vue?vue&type=script&lang=ts&"
import style0 from "./acceptTerms.vue?vue&type=style&index=0&id=19433e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19433e5e",
  null
  
)

export default component.exports